class BookSeries extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector("[data-section-type='cart']");
  }
  async connectedCallback() {
    this._retailCollection = await this._fetchRetailCollection();
    this._fetchItems();
  }
  async _fetchItems() {
    const { productIds, title, image } = this._retailCollection;
    if (!(productIds == null ? void 0 : productIds.length)) {
      this.setAttribute("aria-hidden", true);
      return;
    }
    this.setAttribute("aria-hidden", false);
    this.setAttribute("aria-busy", true);
    this._sectionBatches = [];
    const allProductsLimit = 20;
    const idBatches = [];
    for (let i = 0; i < productIds.length; i += allProductsLimit) {
      idBatches.push(productIds.slice(i, i + allProductsLimit));
    }
    try {
      const fetchPromises = idBatches.map((batch) => {
        const productsIdsStr = batch.join(",");
        let url = `${window.Shopify.routes.root}?sections=${this.ajaxSection}&title=${title}&img_src=${image}&product_ids=${productsIdsStr}`;
        if (this.dataset.carouselId) {
          url += `&carousel_id=${this.dataset.carouselId}`;
        }
        if (this.dataset.carouselName) {
          url += `&carousel_name=${encodeURI(this.dataset.carouselName)}`;
        }
        return fetch(url).then((response) => {
          if (!response.ok) {
            throw new Error(`Failed to fetch: ${response.statusText}`);
          }
          return response.json();
        });
      });
      const responses = await Promise.all(fetchPromises);
      responses.forEach((json) => {
        const tempDiv = document.createElement("DIV");
        tempDiv.innerHTML = json[Object.keys(json)[0]];
        this._sectionBatches.push(tempDiv);
      });
      await this._updateContent();
    } catch (error) {
      console.error("Error fetching product data:", error);
    } finally {
      this.setAttribute("aria-busy", false);
    }
  }
  // method for override
  async _updateContent(html) {
  }
  async _fetchRetailCollection() {
    if (!this.isbn) {
      return {};
    }
    const url = "https://europe-west1-la-bourse-aux-livres.cloudfunctions.net/retailCollection";
    const body = {
      data: {
        type: "series",
        isbn: this.isbn
      }
    };
    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    };
    try {
      const response = await fetch(url, options);
      const json = await response.json();
      if (json.result) {
        const productIds = json.result.opuses.sort((prev, next) => prev.isSeries.sequence - next.isSeries.sequence).map((opus) => opus.isbn);
        return { productIds, title: json.result.title, image: json.result.image };
      }
    } catch (error) {
      console.error(error);
    }
    return {};
  }
  get ajaxSection() {
    return this.dataset.ajaxSection;
  }
  get isbn() {
    return this.dataset.isbn;
  }
}
class BookSeriesItemsForm extends HTMLFormElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener("submit", this._onSubmit.bind(this));
  }
  async _onSubmit(e) {
    e.preventDefault();
    await this._addToCart();
  }
  async _addToCart() {
    const items = this.querySelectorAll('.js-series-item[aria-disabled="false"]');
    const atcItems = new Array();
    const klaviyoItems = new Array();
    items.forEach((item) => {
      var _a, _b;
      klaviyoItems.push(item.atcKlaviyoEventData);
      const properties = {
        Auteur: item.author
      };
      if ((_a = this._collection) == null ? void 0 : _a.title) {
        properties._collectionTitle = item.collection.title;
      }
      if ((_b = this._collection) == null ? void 0 : _b.id) {
        properties._collectionId = item.collection.id;
      }
      atcItems.push({
        id: Number.parseInt(item.variantId),
        quantity: 1,
        properties
      });
    });
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ items: atcItems })
      });
      if (response.ok) {
        this.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              button: this,
              variant: null,
              quantity: atcItems.length
            }
          })
        );
        klaviyoItems.forEach((item, index) => {
          setTimeout(() => {
            console.log("push item", item);
            window.jollyFunctions.klaviyoTrackAddToCart(item);
          }, index * 1e3);
        });
      }
    } catch (error) {
      console.error(error.message);
    }
  }
}
class BookSeriesItem extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest("form");
    this._inputVariantId = this.querySelector("input[name='variant-id']");
    this.author = this.dataset.author || "";
    this.collection = this.dataset.collection ? JSON.parse(this.dataset.collection) : null;
  }
  enable() {
    this.setAttribute("aria-disabled", false);
    this._inputVariantId.disabled = false;
  }
  disable() {
    this.setAttribute("aria-disabled", true);
    this._inputVariantId.disabled = true;
  }
  get variantId() {
    return this._inputVariantId.value;
  }
  set variantId(id) {
    this._inputVariantId.value = id;
  }
  get atcKlaviyoEventData() {
    return this.dataset.atcKlaviyoEventData ? JSON.parse(this.dataset.atcKlaviyoEventData) : null;
  }
}
window.customElements.define("book-series-item", BookSeriesItem);
window.customElements.define("book-series-items-form", BookSeriesItemsForm, {
  extends: "form"
});
export {
  BookSeries as B,
  BookSeriesItemsForm as a,
  BookSeriesItem as b
};
//# sourceMappingURL=book-series.15fd8498.chunk.js.map
